module.exports = __webpack_public_path__ + "img/teich.906e5b98.jpeg";